import app from 'flarum/forum/app';
import { slug } from '../common';
import addRelatedDiscussions from './addRelatedDiscussions';
export { default as extend } from './extend';
app.initializers.add(slug, () => {
  addRelatedDiscussions();
});